import React from "react";
import PageHeader from "../../PageHeader";
import ViewCourses from "./ViewCourses";
import { ReactComponent as CoursesIcon } from "../../../images/courseimage/coursesicon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import { toast } from "react-toastify";
import useStyles from "../../../../styles";
import CourseInBulk from "../../../../BulkCSVFilder/CoursesInBulk.csv"

function Courses() {
  const classes = useStyles();
  
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = CourseInBulk;
    link.setAttribute("download", "CoursesInBulk.csv");

    // Append to the document and trigger the download
    document.body.appendChild(link);
    link.click();

    // Check if the download started (link exists in document)
    if (document.body.contains(link)) {
      toast.success("Sample file for adding branches in bulk has been downloaded");
    } else {
      toast.error("Failed to download the bulk branches file. Please try again.");
    }

    // Clean up
    link.parentNode.removeChild(link);
  };
  const Heading = [
    {
      id: 1,
      pageicon: <CoursesIcon />,
      mainheading: "Courses",
      subhead: "Want to Add in Bulk ?",
      onDownload: handleDownload,
      addbtntext: "Create New Course",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path: "/admin/addcourses",
      showDownloadButton: true,
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <ViewCourses />
    </div>
  );
}
export default Courses;
